/**
 !!!
 Solutions are now stored in AuthorizeDB as resources for each org. For any new solution being added to this list, the steps in
 authorize/service/README.md #Adding new Blueprints/Solutions must be followed.
!!!
*/
export var SolutionType;
(function (SolutionType) {
    SolutionType[SolutionType["Churn"] = 1] = "Churn";
    SolutionType[SolutionType["Forecast"] = 2] = "Forecast";
    SolutionType[SolutionType["CrossSell"] = 3] = "CrossSell";
    SolutionType[SolutionType["Journey"] = 4] = "Journey";
    SolutionType[SolutionType["LifetimeValue"] = 5] = "LifetimeValue";
    SolutionType[SolutionType["Attribution"] = 6] = "Attribution";
    SolutionType[SolutionType["LeadScoring"] = 7] = "LeadScoring";
    SolutionType[SolutionType["Segmentation"] = 8] = "Segmentation";
    SolutionType[SolutionType["GenderPayGap"] = 9] = "GenderPayGap";
    SolutionType[SolutionType["SellerChurn"] = 10] = "SellerChurn";
    SolutionType[SolutionType["SellerPerformance"] = 11] = "SellerPerformance";
    SolutionType[SolutionType["AccrualsForecasting"] = 12] = "AccrualsForecasting";
    SolutionType[SolutionType["Diversity"] = 13] = "Diversity";
    SolutionType[SolutionType["Benchmarking"] = 14] = "Benchmarking";
})(SolutionType || (SolutionType = {}));
/**
 * @deprecated Social Solution Types should no longer be limited
 */
export const SocialSolutionTypes = [SolutionType.GenderPayGap, SolutionType.Diversity, SolutionType.Benchmarking];
export const LatestSolutionVersions = {
    [SolutionType.Churn]: 1,
    [SolutionType.Forecast]: 1,
    [SolutionType.CrossSell]: 1,
    [SolutionType.Journey]: 1,
    [SolutionType.LifetimeValue]: 1,
    [SolutionType.Attribution]: 1,
    [SolutionType.LeadScoring]: 1,
    [SolutionType.Segmentation]: 1,
    [SolutionType.GenderPayGap]: 1,
    [SolutionType.SellerChurn]: 2,
    [SolutionType.SellerPerformance]: 2,
    [SolutionType.AccrualsForecasting]: 1,
    [SolutionType.Diversity]: 2,
    [SolutionType.Benchmarking]: 1
};
//# sourceMappingURL=solutionType.js.map